module.exports = __webpack_public_path__ + "img/ic_discover_challenge.0fcb1c7.svg";